export const NO_DATA_PLACEHOLDER = '-';

export const PERCENTAGE_SYMBOL = '%';

export const RANGE_INPUT_OMITTED_CHARACTERS = ['e', 'E', '+', '-'];
